module Meevo.Plugins.EmployeeTemplates {
  "use strict";

  /**
  * Compensation Section of Employee Template 
  */
  export class CompensationSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.EmployeeTemplateCompensation> {
    public selectedWorkActivityRateDetail: Model.DataDetail;
    private MAX_TIER = 8;

    constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
      handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
      loggingService: Meevo.Components.Logging.ILoggingService,
      dataService: Meevo.Components.BaseClasses.IDataService,
      identityService: Meevo.Components.Common.IIdentityService,
      noun: Meevo.Model.NounEnum,
      protected modalService: Components.Modal.IModalService,
      sectionSecurityKey?:string    ) {

        super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);
      this.modalService = modalService;
    }     

    showCommisionTiers(commission: any): boolean {
      return Model.Guard.isSomething(commission) && commission.scaleType != Model.CommissionScaleTypeEnum.Straight;
    }

    getCurrentTier(commission: any): any {
      return _.last(commission.tiers);
    }

    addWorkActivity(): void {
      let root = <any>this.model;
      if (Model.Guard.isSomething(root)
        && Model.Guard.isSomething(this.selectedWorkActivityRateDetail)
        && _.all(root.workActivityRates, (ec: any) => { return ec.id !== this.selectedWorkActivityRateDetail.id })) {
        {
          root.workActivityRates.push(this.selectedWorkActivityRateDetail);
          this.selectedWorkActivityRateDetail = undefined;
        }
      }
    }

    removeWorkActivity(index: number): void {
      let root = <any>this.model;
      if (Model.Guard.isSomething(root)) {
        root.workActivityRates.splice(index, 1);
      }
    }

    addTier(commission: any): void {
        const count = commission.tiers.length;
        const lastTier = this.getCurrentTier(commission);
        let plus = commission.commissionType !== 2 ? +0.01 : +0.0001;
        if (count >= this.MAX_TIER)
            return;
        commission.tiers.push({ sequence: count, valueFrom: +lastTier.valueTo + plus, valueTo: null });
    }

    removeTier(commission: any): void {
      let count = commission.tiers.length;
      if (count <= 1)
        return;
      commission.tiers.splice(count - 1, 1);

      let lastTier: any = _.last(commission.tiers);
      lastTier.valueTo = null;
    }

    showListControls(index: number, commission: any): boolean {
      return index === commission.tiers.length - 1;
    }

    valueToChanged(tier: any, commission: any): void {
        if (this.isAdding || this.isEditing) {
            if (Model.Guard.isSomething(tier.valueTo)) {
                if (+tier.valueTo <= +tier.valueFrom) {
                    // Notify user of range violation
                    this.modalService.alert("LABEL_COMMISSION_RATE_VIOLATION", Components.Modal.ModalTranslationModes.Translate);
                    tier.valueTo = null;
                }
                else {
                    this.addTier(commission);
                }
            }
        }
    }

    valueFromChanged(tier: any, commission: any): void {
        if (this.isAdding || this.isEditing) {
            if (Model.Guard.isSomething(tier.valueTo) && +tier.valueTo <= +tier.valueFrom) {
                // Notify user of range violation
                this.modalService.alert("LABEL_COMMISSION_RATE_VIOLATION", Components.Modal.ModalTranslationModes.Translate);
                tier.valueFrom = 0;
            }
        }
    }

    isTierCurrent(tier: any, commission: any): boolean {
      let lastTier = this.getCurrentTier(commission);
      return tier.sequence === lastTier.sequence;
    }

    isMaximumTierAllowed(tier: any): boolean {
      return tier.sequence + 1 >= this.MAX_TIER;
    }

    isInitialTier(tier: any, commission: any): boolean {
      let firstTier: any = _.first(commission.tiers);
      return tier.sequence === firstTier.sequence;
    }

    isSectionAdding(): boolean {
      return this.mode === Meevo.Model.MaintenanceFormState.Adding;
    }

    isSectionEditing(): boolean {
      return this.mode === Meevo.Model.MaintenanceFormState.Editing;
    }

    isSectionReadonly(): boolean {
      return this.mode === Meevo.Model.MaintenanceFormState.Readonly;
    }

  }
}